import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {LiveJobPage} from '../pages/LiveJobPage'

const {PUBLIC_URL} = process.env

/**
 * Routing model:
 * - Shared: error pages, logout.
 * - `live-job` is registered inside BOTH auth branches and listed BEFORE any splat (`*` / `/*`)
 *   so `/live-job` never falls through to `<Navigate to="/auth" />` for guests or to PrivateRoutes
 *   for logged-in users.
 */
const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              {/* More specific first: /live-job/:key — plain /live-job is query-string only */}
              <Route path='live-job/:jobKey' element={<LiveJobPage />} />
              <Route path='live-job' element={<LiveJobPage />} />
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/vehicle-monitoring' />} />
            </>
          ) : (
            <>
              <Route path='live-job/:jobKey' element={<LiveJobPage />} />
              <Route path='live-job' element={<LiveJobPage />} />
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' replace />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
